import { render } from "./putTime.vue?vue&type=template&id=2a0c7ed0&scoped=true"
import script from "./putTime.vue?vue&type=script&lang=js"
export * from "./putTime.vue?vue&type=script&lang=js"

import "./putTime.vue?vue&type=style&index=0&id=2a0c7ed0&lang=scss&scoped=true"

import exportComponent from "/root/workspace/adx-frontend_wteR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a0c7ed0"]])

export default __exports__